module.exports = __webpack_public_path__ + "_assets/img/background.cfa634d5.png";